if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // onSubmitHandler(evt) {
      //   evt.preventDefault();

      //   const TARGET_PRODUCT_ID = [8400028270637, 8442084360237]; // your main product ID
      //   const FREE_VARIANT_ID = 44411384660013; // free product variant ID

      //   const input = this.form.querySelector('.custom-keychain-name');
      //   const input1 = document.querySelector('.custom-name');
        
      //   const error = this.form.querySelector('.custom-keychain-error');
      //   const error1 = this.form.querySelector('.custom-name-error');
      //   if (input) {
      //     const value = input.value.trim();
      //     const RE_EMOJI_SYMBOLS = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
      //     const valid = value.length > 0 && value.length <= 11 && /^[A-Za-z0-9]+$/.test(value) && value.replace(RE_EMOJI_SYMBOLS,'');
      //     // debugger;
      //     if (!valid) {
      //       error.style.display = 'block';
      //       input.focus();
      //       return false;
      //     } else {
      //       error.style.display = 'none';
      //     }
      //   }

      //   if (input1) {
      //     const value1 = input1.value.trim();
      //     const RE_EMOJI_SYMBOLS = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
      //     const valid1 = value1.length > 0 && value1.length <= 11 && /^[A-Za-z0-9]+$/.test(value1) && value1.replace(RE_EMOJI_SYMBOLS,'');
      //     // debugger;
      //     if (!valid1) {
      //       error1.style.display = 'block';
      //       input1.focus();
      //       return false;
      //     } else {
      //       error1.style.display = 'none';
      //     }
      //   }
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   this.querySelector('.loading__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   debugger;
      //   const formData = new FormData(this.form);
      //   const selectedVariantId = parseInt(formData.get('id'));
      //   const quantity = parseInt(formData.get('quantity')) || 1;

      //   console.log('formData',formData);

      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }
      //       if (TARGET_PRODUCT_ID.includes(response.product_id)) {
      //         const input = this.form.querySelector('.custom-keychain-name');
      //         const colorName = this.form.querySelector('.custom_color');
      //         const keychainname = input.value.trim();
      //         fetch('/cart/add.js', {
      //           method: 'POST',
      //           headers: { 'Content-Type': 'application/json' },
      //           body: JSON.stringify({
      //             id: FREE_VARIANT_ID,
      //             quantity: quantity,
      //             properties: { "_free_gift": "true", "Name": keychainname, "Color": colorName.value }
      //           })
      //         })
      //         .then(() => {

      //           // ✅ Get section HTML (IMPORTANT)
      //           const sections = this.cart.getSectionsToRender().map(s => s.id).join(',');

      //           return fetch(`/cart?sections=${sections}&sections_url=${window.location.pathname}`)
      //             .then(res => res.json());
      //         })
      //         .then((sectionsData) => {

      //           // ✅ Build EXACT structure your cart expects
      //           const updatedCart = {
      //             id: response.id, // or Date.now()
      //             sections: sectionsData
      //           };

      //           // ✅ Now safe to render
      //           this.cart.renderContents(updatedCart);

      //         });

      //         return;
      //       }
      //       const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           cartData: response,
      //         }).then(() => {
      //           CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      //         });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               CartPerformance.measure("add:paint-updated-sections", () => {
      //                 this.cart.renderContents(response);
      //               });
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         CartPerformance.measure("add:paint-updated-sections", () => {
      //           this.cart.renderContents(response);
      //         });
      //       }
            
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       this.querySelector('.loading__spinner').classList.add('hidden');

      //       CartPerformance.measureFromEvent("add:user-action", evt);
      //     });
      // }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const productID = evt.currentTarget.dataset.productId;
        const TARGET_PRODUCT_ID = [15127457955885]; // your main product ID
        const input = this.form.querySelector('.custom-keychain-name');
        const error = this.form.querySelector('.custom-name-error');
        if (input) {
          const value = input.value.trim();
          const RE_EMOJI_SYMBOLS = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
          const valid = value.length > 0 && value.length <= 11 && /^[A-Za-z0-9]+$/.test(value) && value.replace(RE_EMOJI_SYMBOLS,'');
          // debugger;
          if (!valid) {
            error.style.display = 'block';
            input.focus();
            return false;
          } else {
            error.style.display = 'none';
          }
        }

        if(productID == TARGET_PRODUCT_ID){

        console.log("productID", productID)

        const input1 = this.form.querySelector('.custom-name');
        const error1 = this.form.querySelector('.custom-error');

          if (input1) {
            const value1 = input1.value.trim();
            const RE_EMOJI_SYMBOLS = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
            const valid1 = value1.length > 0 && value1.length <= 11 && /^[A-Za-z0-9]+$/.test(value1) && value1.replace(RE_EMOJI_SYMBOLS,'');
            // debugger;
            if (!valid1) {
              error1.style.display = 'block';
              input1.focus();
              return false;
            } else {
              error1.style.display = 'none';
            }
          }
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// document.addEventListener('DOMContentLoaded', function () {
//   const input1 = document.querySelector('.custom-keychain-name'); // optional
//   const input2 = document.querySelector('.custom-name'); // optional

//   const error1 = document.querySelector('.custom-keychain-error');
//   const error2 = document.querySelector('.custom-name-error');

//   const buyNowBtn = document.querySelector('.shopify-payment-button__button');

//   if (!buyNowBtn) return; // only button is mandatory

//   let hasTyped1 = false;
//   let hasTyped2 = false;

//   const RE_EMOJI_SYMBOLS = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;

//   function isValidValue(value) {
//     return (
//       value.length > 0 &&
//       value.length <= 11 &&
//       /^[A-Za-z0-9]+$/.test(value) &&
//       value.replace(RE_EMOJI_SYMBOLS, '')
//     );
//   }

//   function validateInput() {
//     let valid1 = true;
//     let valid2 = true;

//     // ✅ FIELD 1 (if exists)
//     if (input1) {
//       const value1 = input1.value.trim();
//       const isEmpty1 = value1.length === 0;
//       valid1 = isValidValue(value1);

//       if (isEmpty1) {
//         error1 && (error1.style.display = 'none');
//         valid1 = false;
//       } else if (!valid1 && hasTyped1) {
//         error1 && (error1.style.display = 'block');
//       } else {
//         error1 && (error1.style.display = 'none');
//       }
//     }

//     // ✅ FIELD 2 (if exists)
//     if (input2) {
//       const value2 = input2.value.trim();
//       const isEmpty2 = value2.length === 0;
//       valid2 = isValidValue(value2);

//       if (isEmpty2) {
//         error2 && (error2.style.display = 'none');
//         valid2 = false;
//       } else if (!valid2 && hasTyped2) {
//         error2 && (error2.style.display = 'block');
//       } else {
//         error2 && (error2.style.display = 'none');
//       }
//     }

//     // ✅ FINAL BUTTON STATE
//     const finalValid =
//       (input1 ? valid1 : true) &&
//       (input2 ? valid2 : true);

//     if (!finalValid) {
//       buyNowBtn.setAttribute('disabled', true);
//       buyNowBtn.style.pointerEvents = 'none';
//       buyNowBtn.style.opacity = '0.5';
//     } else {
//       buyNowBtn.removeAttribute('disabled');
//       buyNowBtn.style.pointerEvents = 'auto';
//       buyNowBtn.style.opacity = '1';
//     }
//   }

//   // 🔥 EVENTS (only attach if field exists)
//   if (input1) {
//     input1.addEventListener('input', function () {
//       hasTyped1 = true;
//       validateInput();
//     });
//   }

//   if (input2) {
//     input2.addEventListener('input', function () {
//       hasTyped2 = true;
//       validateInput();
//     });
//   }

//   // 👇 Initial run
//   validateInput();
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const input = document.querySelector('.custom-keychain-name');
//   const error = document.querySelector('.custom-name-error');
//   const buyNowBtn = document.querySelector('.shopify-payment-button__button');

//   if (!input || !buyNowBtn) return;

//   let hasTyped = false;

//   function validateInput() {
//     const value = input.value.trim();
//     const RE_EMOJI_SYMBOLS = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;

//     const isEmpty = value.length === 0;

//     const isValid =
//       !isEmpty &&
//       value.length <= 11 &&
//       /^[A-Za-z0-9]+$/.test(value) &&
//       value.replace(RE_EMOJI_SYMBOLS, '');

//     // 👇 CASE 1: Empty → disable button, NO error
//     if (isEmpty) {
//       error.style.display = 'none';
//       buyNowBtn.setAttribute('disabled', true);
//       buyNowBtn.style.pointerEvents = 'none';
//       buyNowBtn.style.opacity = '0.5';
//       return;
//     }

//     // 👇 CASE 2: Invalid after typing → show error
//     if (!isValid) {
//       if (hasTyped) {
//         error.style.display = 'block';
//       }
//       buyNowBtn.setAttribute('disabled', true);
//       buyNowBtn.style.pointerEvents = 'none';
//       buyNowBtn.style.opacity = '0.5';
//       return;
//     }

//     // 👇 CASE 3: Valid
//     error.style.display = 'none';
//     buyNowBtn.removeAttribute('disabled');
//     buyNowBtn.style.pointerEvents = 'auto';
//     buyNowBtn.style.opacity = '1';
//   }

//   input.addEventListener('input', function () {
//     hasTyped = true;
//     validateInput();
//   });

//   // 👇 IMPORTANT: Run once to disable Buy Now initially
//   validateInput();
// });


(function () {
  'use strict';

  /* ---------- CONFIG ---------- */
  var INPUT_SELECTOR = '.custom-keychain-name';
  var ERROR_SELECTOR = '.custom-name-error';
  var TARGET_SELECTOR = 'magic-checkout-btn, .magic-buy-btn__parent, .shopify-payment-button';
  var ADD_TO_CART_SELECTOR = 'button[name="add"], .product-form__submit, [data-add-to-cart]';
  var ERROR_HIDE_DELAY = 4000;
  var DIM_WHEN_INVALID = true;
  var DEBUG = true; // logs to console, set false when done
  /* ---------------------------- */

  var errorTimer, rafId;
  var overlays = new Map(); // target element -> overlay element

  function log() {
    if (DEBUG) console.log.apply(console, ['[name-guard]'].concat([].slice.call(arguments)));
  }

  var style = document.createElement('style');
  style.textContent =
    '.name-guard-overlay{position:fixed;z-index:2147483647;cursor:not-allowed;background:transparent;display:none;}' +
    (DIM_WHEN_INVALID ? '.name-guard-dim{opacity:.5!important;}' : '');
  document.head.appendChild(style);

  function getInput() { return document.querySelector(INPUT_SELECTOR); }
  function getError() { return document.querySelector(ERROR_SELECTOR); }

  function isValidName(v) { return /^[A-Za-z0-9]{1,11}$/.test((v || '').trim()); }
  function isNameValid() { var i = getInput(); return !i || isValidName(i.value); }

  function hideError() {
    var e = getError();
    if (e) e.style.display = 'none';
    clearTimeout(errorTimer);
  }

  function showError() {
    var input = getInput(), error = getError();
    if (error) error.style.display = 'block';
    if (input) {
      input.focus();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    clearTimeout(errorTimer);
    if (ERROR_HIDE_DELAY > 0) errorTimer = setTimeout(hideError, ERROR_HIDE_DELAY);
  }

  function block(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    showError();
  }

  // Outermost-to-innermost: use the innermost match so we don't double up
  function getTargets() {
    var all = Array.prototype.slice.call(document.querySelectorAll(TARGET_SELECTOR));
    return all.filter(function (el) {
      return !all.some(function (other) { return other !== el && el.contains(other); });
    });
  }

  function getOverlay(target) {
    var ov = overlays.get(target);
    if (ov && document.body.contains(ov)) return ov;

    ov = document.createElement('div');
    ov.className = 'name-guard-overlay';
    ['click', 'mousedown', 'mouseup', 'pointerdown', 'pointerup', 'touchstart', 'touchend'].forEach(function (evt) {
      ov.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (evt === 'click' || evt === 'touchend') showError();
      }, { passive: false });
    });
    document.body.appendChild(ov);
    overlays.set(target, ov);
    return ov;
  }

  function sync() {
    var valid = isNameValid();
    var targets = getTargets();

    // Remove overlays whose button no longer exists
    overlays.forEach(function (ov, t) {
      if (!document.body.contains(t)) {
        ov.remove();
        overlays.delete(t);
      }
    });

    targets.forEach(function (t) {
      var ov = getOverlay(t);
      var rect = t.getBoundingClientRect();
      if (rect.height < 5 && t.parentElement) rect = t.parentElement.getBoundingClientRect();

      var visible = !valid && rect.width > 0 && rect.height > 0;
      ov.style.display = visible ? 'block' : 'none';
      if (visible) {
        ov.style.top = rect.top + 'px';
        ov.style.left = rect.left + 'px';
        ov.style.width = rect.width + 'px';
        ov.style.height = rect.height + 'px';
      }
      t.classList.toggle('name-guard-dim', !valid);
    });
  }

  function scheduleSync() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () { rafId = null; sync(); });
  }

  // Add to cart + any direct clicks that reach the page
  window.addEventListener('click', function (e) {
    if (!getInput() || !e.target.closest) return;
    var hit = e.target.closest(ADD_TO_CART_SELECTOR) || e.target.closest(TARGET_SELECTOR);
    if (hit && !isNameValid()) block(e);
  }, true);

  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !getInput()) return;
    var isProductForm = f.matches('form[action*="/cart/add"]') || f.querySelector(ADD_TO_CART_SELECTOR);
    if (isProductForm && !isNameValid()) block(e);
  }, true);

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches(INPUT_SELECTOR)) return;
    var cleaned = e.target.value.replace(/[^A-Za-z0-9]/g, '').slice(0, 11);
    if (cleaned !== e.target.value) e.target.value = cleaned;
    if (isValidName(cleaned)) hideError();
    sync();
  });

  // Keep overlay aligned and re-applied (late load, re-render, scroll, resize)
  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true
  });
  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);
  setInterval(sync, 500); // light safety net

  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', function () {
    sync();
    log('targets found:', getTargets().length, getTargets());
  });
  sync();
})();